import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { StoreProvider } from './components';
import { IdentityProvider } from './identity/IdentityProvider';
import { BASE_URL } from './constants';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Identity wraps everything: the school's colours are applied as CSS
  // variables before the tree paints, so no component has to know which school
  // it is rendering for.
  <React.StrictMode>
    <IdentityProvider baseUrl={BASE_URL}>
      <StoreProvider>
        <App />
      </StoreProvider>
    </IdentityProvider>
  </React.StrictMode>
);
